<template>
  <span id="add-holiday-period">
    <el-button id="btn-add-holiday-period" type="success" plain @click="handleOpenDialog" class="margin-r-10"
               size="mini">{{ $t('admin.holidayPeriods.addHolidayPeriod') }}</el-button>
    <el-dialog
      width="60%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('admin.holidayPeriods.addHolidayPeriod')"
      class="dialog-with-cols"
    >
      <el-form :model="addForm" :rules="addFormRules" label-position="top" ref="addForm" size="mini">
        <el-row>
          <el-col :md="16" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.holidayPeriods.name')" prop="name" ref="name" class="inline-input">
              <el-input
                v-model="addForm.name"
                maxlength="255"
                clearable
                class="inline-input"
                id="addForm-name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.holidayPeriods.regions')" prop="regionIds" ref="regionIds" class="inline-input">
              <el-select
                  v-model="addForm.regionIds"
                  multiple
                  placeholder="Select regions"
                  style="width: 100%">
                <el-option
                    v-for="region in regions"
                    :key="region.id"
                    :label="region.code"
                    :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.holidayPeriods.effectiveDate')" prop="effectiveDate" ref="effectiveDate" class="inline-input">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  size="mini"
                  v-model="addForm.effectiveDate"
                  format="MM/dd/yyyy"
                  :clearable="false"
                  :picker-options="effectiveDateOptions"
                  type="date"
                  style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.holidayPeriods.expirationDate')" prop="expirationDate" ref="expirationDate" class="inline-input">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  size="mini"
                  v-model="addForm.expirationDate"
                  format="MM/dd/yyyy"
                  :clearable="false"
                  :picker-options="expirationDateOptions"
                  type="date"
                  style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.holidayPeriods.earlyAccess')" class="inline-input">
              <el-checkbox v-model="addForm.earlyAccess"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClear" size="mini">{{ $t('common.clear') }}</el-button>
        <el-button type="primary" @click="handleSave" size="mini" :loading="loading">{{ $t('common.save') }}</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AddHolidayPeriod',
  computed: {
    ...mapState({
      regions: state => state.holidayPeriods.regions
    })
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      addForm: {
        name: '',
        effectiveDate: null,
        expirationDate: null,
        regionIds: [],
        earlyAccess: false
      },
      addFormRules: {
        name: [
          { required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'blur' }
        ],
        effectiveDate: [
          { required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'change' }
        ],
        expirationDate: [
          { required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'change' }
        ],
        regionIds: [
          {
            required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'change', type: 'array'
          }
        ]
      },
      effectiveDateOptions: {
        disabledDate(date) {
          return date < new Date(new Date().setHours(0, 0, 0, 0));
        }
      },
      expirationDateOptions: {
        disabledDate(date) {
          return date < new Date(new Date().setHours(0, 0, 0, 0));
        }
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.handleClear();
    },
    handleClear() {
      this.addForm = {
        name: '',
        effectiveDate: null,
        expirationDate: null,
        regionIds: [],
        earlyAccess: false
      };
      this.$refs.addForm.clearValidate();
    },
    handleSave() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          this.$store.dispatch('holidayPeriods/create', this.addForm).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('admin.holidayPeriods.createSuccess')
            });
            this.dialogVisible = false;
            this.$store.dispatch('holidayPeriods/search');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    }
  }
};
</script>
